/* eslint-env browser */

'use strict';
import { DashRenderer } from './DashRenderer'

// make DashRenderer globally available
window.DashRenderer = DashRenderer;
